module.exports = __webpack_public_path__ + "img/list20231114001.8261dce2.jpg";